"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecretValue = getSecretValue;
exports.isLoopingStrategyProfitable = isLoopingStrategyProfitable;
exports.checkProfitability = checkProfitability;
const decimal_js_1 = require("decimal.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const client_secrets_manager_1 = require("@aws-sdk/client-secrets-manager");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
const lending_1 = require("@naviprotocol/lending");
const naviPolyfill_js_1 = require("./naviPolyfill.js");
// import dotenv from "dotenv";
// Load environment variables from .env file
// dotenv.config();
const secretsClient = new client_secrets_manager_1.SecretsManagerClient({
    region: process.env.AWS_REGION,
});
const poolName = process.env.POOL_NAME;
const tableName = process.env.HOLDERS_CONF_TABLE_NAME;
const client = new client_dynamodb_1.DynamoDBClient({});
const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(client);
const partitionKey = "id";
const uniqueId = `${poolName}-looping-profitability-previous-result`;
const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
async function getSecretValue(secretArn) {
    try {
        const command = new client_secrets_manager_1.GetSecretValueCommand({
            SecretId: secretArn,
        });
        const secret = await secretsClient.send(command);
        return secret.SecretString;
    }
    catch (e) {
        console.error("Error retrieving secret:", e);
    }
}
async function isLoopingStrategyProfitable(poolName) {
    const supplyCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].supplyCoin;
    const borrowCoin = alphafi_sdk_1.loopingPoolCoinMap[poolName].borrowCoin;
    const supplyCoinType = alphafi_sdk_1.coinsList[supplyCoin].type;
    const borrowCoinType = alphafi_sdk_1.coinsList[borrowCoin].type;
    let supplyApr = new decimal_js_1.Decimal(0);
    let borrowApr = new decimal_js_1.Decimal(0);
    let parentProtocolSupplyApr = new decimal_js_1.Decimal(0);
    let parentProtocolBorrowApr = new decimal_js_1.Decimal(0);
    if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "NAVI") {
        const [naviSupplyPoolInfo, naviBorrowPoolInfo] = await (0, naviPolyfill_js_1.withNaviFetch)(async () => {
            return Promise.all([(0, lending_1.getPool)(supplyCoinType), (0, lending_1.getPool)(borrowCoinType)]);
        });
        parentProtocolSupplyApr = new decimal_js_1.Decimal(Number(naviSupplyPoolInfo.supplyIncentiveApyInfo.boostedApr) +
            Number(naviSupplyPoolInfo.supplyIncentiveApyInfo.vaultApr));
        parentProtocolBorrowApr = new decimal_js_1.Decimal(Number(naviBorrowPoolInfo.borrowIncentiveApyInfo.boostedApr) -
            Number(naviBorrowPoolInfo.borrowIncentiveApyInfo.vaultApr));
    }
    else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        const supplyMarket = await alphalendClient.getMarketDataFromId(Number(alphafi_sdk_1.alphalendMarketIdMap[supplyCoin]));
        const borrowMarket = await alphalendClient.getMarketDataFromId(Number(alphafi_sdk_1.alphalendMarketIdMap[borrowCoin]));
        const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
        if (!investor) {
            throw new Error(`could not fetch investor for ${poolName}`);
        }
        if (supplyMarket) {
            let totalRewardApr = 0;
            for (const x of supplyMarket.supplyApr.rewards) {
                totalRewardApr += Number(x.rewardApr);
            }
            parentProtocolSupplyApr = new decimal_js_1.Decimal(Number(supplyMarket.supplyApr.interestApr) +
                Number(totalRewardApr) +
                Number(supplyMarket.supplyApr.stakingApr));
        }
        else {
            // throw new Error("could not fetch markets");
            console.error("fetch supply market failed");
        }
        if (borrowMarket) {
            let totalRewardApr = 0;
            for (const x of borrowMarket.borrowApr.rewards) {
                totalRewardApr += Number(x.rewardApr);
            }
            parentProtocolBorrowApr = new decimal_js_1.Decimal(-Number(borrowMarket.borrowApr.interestApr) + totalRewardApr);
        }
        else {
            // throw new Error("could not fetch markets");
            console.error("fetch borrow market failed");
        }
    }
    const investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, false));
    if (!investor) {
        throw new Error(`couldnt fetch ${poolName} investor`);
    }
    const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.toString()).div(1e20);
    supplyApr = parentProtocolSupplyApr.div(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio));
    borrowApr = parentProtocolBorrowApr
        .mul(debtToSupplyRatio)
        .div(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio));
    console.log(parentProtocolSupplyApr.toSignificantDigits(5), parentProtocolBorrowApr, supplyApr.add(borrowApr).toSignificantDigits(5));
    if (supplyApr
        .add(borrowApr)
        .toSignificantDigits(5)
        .greaterThan(parentProtocolSupplyApr.toSignificantDigits(5))) {
        return 1; // if stratgy is profitable and making more than simply supplying
    }
    else if (supplyApr.add(borrowApr).greaterThan(0)) {
        return 0; // if strategy is profitable but making lesser than simply supplying
    }
    else {
        return -1; // strategy is not profitable.
    }
}
async function checkProfitability() {
    try {
        if (!poolName) {
            throw new Error(`poolName not set in env`);
        }
        const result = await isLoopingStrategyProfitable(poolName);
        const previousResult = await getNumber();
        if (previousResult.length > 0) {
            if (previousResult[0].value.N !== result?.toString()) {
                await sendMessageBasedOnResult(result);
                await updateNumber(Number(previousResult[0].value.N), result);
            }
        }
        else {
            await sendMessageBasedOnResult(result);
            await putItem(result);
        }
    }
    catch (err) {
        await sendTelegramMessage(`Error in ${poolName}, ` + err);
    }
}
const sendTelegramMessage = async (message) => {
    const BOT_TOKEN = await getSecretValue(process.env.LOOPING_PROFITABILITY_BOT_TOKEN);
    // const BOT_TOKEN = process.env.LOOPING_PROFITABILITY_BOT_TOKEN!;
    const CHAT_ID = await getSecretValue(process.env.LOOPING_PROFITABILITY_GROUP_ID);
    // const CHAT_ID = process.env.LOOPING_PROFITABILITY_GROUP_ID!;
    const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
    const params = {
        chat_id: CHAT_ID,
        text: message,
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
        if (!response.ok) {
            throw new Error(`Failed to send message: ${response.statusText}`);
        }
        const result = await response.json();
        console.log(`Telegram message sent: ${result.result.message_id}`);
    }
    catch (error) {
        console.error("Error sending Telegram message:", error);
    }
};
const sendMessageBasedOnResult = async (result) => {
    if (result === -1) {
        await sendTelegramMessage(`${poolName} strategy is not profitable.`);
    }
    else if (result === 0) {
        await sendTelegramMessage(`${poolName} strategy is profitable but making lesser than simply supplying`);
    }
    else {
        await sendTelegramMessage(`${poolName} strategy is profitable and making more than simply supplying`);
    }
};
const putItem = async (val) => {
    const params = {
        TableName: tableName,
        Item: {
            [partitionKey]: uniqueId,
            value: val,
        },
    };
    try {
        await ddbDocClient.send(new lib_dynamodb_1.PutCommand(params));
        console.log("Item initialized");
    }
    catch (error) {
        console.error("Error initializing item:", error);
    }
};
const getNumber = async () => {
    const params = {
        TableName: tableName,
        KeyConditionExpression: "id = :id", // Only filter by partition key (id)
        ExpressionAttributeValues: {
            ":id": { S: uniqueId }, // The id is a string
        },
    };
    try {
        const { Items } = await ddbDocClient.send(new client_dynamodb_1.QueryCommand(params));
        if (Items && Items.length > 0) {
            // If there are results
            console.log("Items retrieved:", Items);
            return Items; // Return all items with the same partition key
        }
        else {
            // No items found for this idsc
            console.log("No items found for id:", uniqueId);
            return []; // Return an empty array if no items are found
        }
    }
    catch (error) {
        console.error("Error querying items:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};
const updateNumber = async (value, newValue) => {
    // First, delete the old item
    const deleteParams = {
        TableName: tableName,
        Key: {
            id: uniqueId, // Partition key
        },
    };
    try {
        // Delete the old item
        await ddbDocClient.send(new lib_dynamodb_1.DeleteCommand(deleteParams));
        console.log("Old item deleted successfully.");
        await putItem(newValue);
    }
    catch (error) {
        console.error("Error updating item:", error);
        throw error;
    }
};
//# sourceMappingURL=loopingProfitableCheck.js.map